import React, { useRef } from 'react';

interface Props {
  src: string | undefined | null;
  alt: string;
  isLoading?: boolean;
  className?: string;
  testId?: string;
  fallbackUrl?: string;
  onError?: () => void;
}

const Image: React.FC<Props> = ({
  src,
  isLoading,
  alt,
  testId,
  fallbackUrl = '/Images/BrokenImage.svg',
  className = '',
  onError
}) => {
  const imgRef = useRef<HTMLImageElement>(null);

  const _src = src ? encodeURI(src) : '/Images/NoImage.svg';

  if (isLoading) {
    return <div data-testid={testId || undefined} className={`LoadingCoverImage ${className}`} />;
  }

  return (
    <img
      ref={imgRef}
      onError={({ currentTarget }) => {
        currentTarget.onerror = null;
        currentTarget.src = fallbackUrl;
        if (onError) onError();
      }}
      data-testid={testId || undefined}
      className={className}
      alt={alt}
      src={_src}
    />
  );
};

export default Image;
